import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  districtInitialValues,
  districtMandatoryFields,
  districtProperties,
  districtValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { isEmpty } from "utils/helpers";
import { useMutation } from "@apollo/client";
import { CREATE_DISTRICT } from "utils/graphql/services/entities/mutations";
import entitesClient from "utils/graphql/entitiesClient";
import { getValueFromMetadata } from "pages/entities/helper";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import LoadingButton from "@mui/lab/LoadingButton";

export const DistrictCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    districtInitialValues,
    districtValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const [createDistrict, { loading, error, data }] = useMutation(CREATE_DISTRICT, {
    client: entitesClient // Ensure you're using the correct GraphQL client instance
  });
  
  const handleCreateDistrict = async () => {
    try {
      const response:any = await createDistrict({
        variables: {
          input: {
            name: watch()?.name,
            State: watch()?.state,
            sbdStateId: getValueFromMetadata(metaData,"state_list", "state_id", watch()?.state,"sbd_state_id"),
            sbdDistrictId: +watch()?.sbdDistrictId,
          },
        },
      });
  
      if (!isEmpty(response?.data?.createDistrict)) {
        dispatch(snackbarRequest({ message: "Created District successfully" }));
        history.replace(`/entities/district`);
      } else {
        dispatch(snackbarRequest({ message: `${response?.errorReason}`,type: "error"  }));
      }
    } catch (err:any) {
      dispatch(snackbarRequest({ message: `${err?.message}`,type: "error"  }));
    }
  };
  return (
    <div>
      <TypographyHeading>Create District</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={districtProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              loading={loading}
              sx={{
                width: "180px",
                height: "40px",
                marginTop: "15px",
                marginRight: "0px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
               onClick={handleCreateDistrict}
               disabled={!isFieldsValidate(errors, districtMandatoryFields, getValues)}
            >
              Create District
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
